/**
 * Formatare dimensiune fisier in format human-readable.
 * (compresia efectiva nu se mai face - pozele se trimit la Telegram exact cum vin)
 */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}
